import React from 'react';
import seo from '../SEO/data';

export default function SocialLinks({ footer = false }) {
	return (
		<div className='flex space-x-5'>
			{seo.social.nav.map((item) => (
				<a
					key={item.name}
					target='_blank'
					rel='noreferrer'
					href={item.href}
					className={
						footer
							? 'text-white/60 hover:text-accent-300 transition-colors'
							: 'text-ink-500 hover:text-primary-500 transition-colors'
					}
				>
					<span className='sr-only'>{item.name}</span>
					<item.icon className='h-5 w-5' aria-hidden='true' />
				</a>
			))}
		</div>
	);
}
